module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-152x152-7cd3a77934e4a1dd594cdf16010358a4.png";